import React,{ useState, useRef } from 'react';
import { isAuthenticated } from "../../../../auth";
import Layout from "../../../../core/Layout";
import { submitProofData, submitProofImage } from '../../../walletApi'
import { makeStyles } from '@material-ui/core/styles';
import { Container, 
         Paper, 
         Typography, 
         Box, 
         Button,
         TextField 
       }from '@material-ui/core';



const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(1),
      width: theme.spacing(50),
      height: theme.spacing(50),
    }
  },
  cardSpace:{marginTop: "250px", margin: "auto"}
}));

const SubmitProof = ({...props}) =>{
  const {user, token } = isAuthenticated();
  const classes = useStyles();
  const fileInput = useRef(null);
  const [fileImage, setFileImage ]= useState(null)
  const [formData, setFormData] = useState({})

  const data = {
    accountName:formData.accountName, 
    accountNumber:formData.accountNumber, 
    amount: formData.amount}

  const handleClick = (e) => {
    e.preventDefault();
    fileInput.current.click();
  };
  const handleChange = (event) => {
    const file = event.target.files[0];
    // you can use the file here
    setFileImage(file)
  };

  const handleSubmit = (e) =>{
    e.preventDefault()
      submitProofData(user._id,data, token).then((data = []) => {
        if (data && data.error) {
           console.log(data.error) 
        } else {
          submitProofImage(data.body._id, fileImage)
          .then((data) =>{
              if(data && data.error){
                console.log(data.error)
              }else{
               console.log(data)
              }
          })
           
        }
    });
  }

    return(
      <Layout>
        <Container>
            <Box className={classes.root}>
              <Box className={classes.cardSpace} id="elementId">
                <Typography> </Typography>
                <Paper elevation={3}>
                <form noValidate autoComplete="off" >
                    <Typography> AccountName</Typography>
                    <TextField 
                      id="outlined-basic" 
                      label="Expiration year" 
                      variant="outlined"
                      value={formData.accountName}
                      onChange={(e) => 
                        setFormData({...formData, accountName: e.target.value
                      })} 
                    />
                    <Typography> AccountNumber</Typography>
                    <TextField 
                      id="outlined-basic" 
                      label="Expiration year" 
                      variant="outlined"
                      value={formData.accountNumber}
                      onChange={(e) => 
                        setFormData({...formData, accountNumber: e.target.value
                      })} 
                    />
                    <Typography> Amount</Typography>
                    <TextField 
                      id="outlined-basic" 
                      label="Expiration year" 
                      variant="outlined"
                      value={formData.amount}
                      onChange={(e) => 
                        setFormData({...formData, amount: e.target.value
                      })} 
                    />
                    <Typography> Payment Method</Typography>
                    <button onClick={handleClick}>Open File</button>
                    <input type="file" name="file" ref={fileInput} onChange={handleChange} style={{ display: "none" }}/>
                    <Button
                      type='submit' 
                      variant="contained" 
                      color="secondary"
                      onClick={handleSubmit}
                      >
                        Submit Proof
                    </Button>
                </form>
                </Paper>
              </Box>
            </Box>
        </Container>
      </Layout>
    )
}

export default SubmitProof;